import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Button } from '../../ui';
import './ActivityTabV2.css';

/**
 * The AI-generated description of a task (the part after
 * `--- AI-Generated Description ---`, split off by utils/unitActivities
 * splitDetails) in its own block with Copy. Shared by the unit Activity tab
 * and the Task Board preview (QA T-2).
 */
export default function AiDescription({ text }) {
    const [copied, setCopied] = useState(false);
    useEffect(() => {
        if (!copied) return undefined;
        const t = setTimeout(() => setCopied(false), 2000);
        return () => clearTimeout(t);
    }, [copied]);
    const copy = () => {
        try {
            const p = navigator.clipboard?.writeText(text);
            if (p && typeof p.then === 'function') p.then(() => setCopied(true), () => {});
            else setCopied(true);
        } catch (e) { /* clipboard refused */ }
    };
    return (
        <div className="u2-act-ai">
            <div className="u2-act-ai-h">
                <span className="v2-eyebrow u2-eyebrow">AI-Generated Description</span>
                <Button size="sm" onClick={copy}>{copied ? '✓ Copied' : 'Copy'}</Button>
            </div>
            <p className="u2-act-ai-t">{text}</p>
        </div>
    );
}
AiDescription.propTypes = { text: PropTypes.string.isRequired };
